import { css } from "@emotion/react";

export const content = css`
  height: 100%;
  margin-top: 80px; /* makes room for the nav */
`;
